module.exports = {
	"pagination": {
		"DescribeAutoScalingGroups": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "AutoScalingGroups"
		},
		"DescribeAutoScalingInstances": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "AutoScalingInstances"
		},
		"DescribeLaunchConfigurations": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "LaunchConfigurations"
		},
		"DescribeNotificationConfigurations": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "NotificationConfigurations"
		},
		"DescribePolicies": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "ScalingPolicies"
		},
		"DescribeScalingActivities": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "Activities"
		},
		"DescribeScheduledActions": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "ScheduledUpdateGroupActions"
		},
		"DescribeTags": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "Tags"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/autoscaling-2011-01-01.paginators.json
// module id = 1270
// module chunks = 0